import React from "react";
import { Select, Row, Col, Form, Divider } from "antd";
import moment from "moment";
import UserSessionData from "../../../../MyAccounts/Components/InviteInterestedParties/Components/userSessionData";
import FormItem from "antd/lib/form/FormItem";
import {
  EmailWrapper,
  EmailTitleWrapper,
  InputWrapperdropFixedwidth,
  InputWrapperfixedwidth,
  SecurityNumWrap,
  TitleWrapper,
  RowWrapper,
  Err,
  SelectOptionMainWrapper,
  DescriptionPara,
  TitleMarginTop,
  SelectdropwownStyles,
  WrapLabel
} from "../../../Components/Step1Setup/styles";
import {
  DivisonCategory,
  SubDivisonCategory,
  InvitePartiesFixedWidth,
  RelativePositionDiv,
  DropDownNoResult,
  InputWrappercal, 
  ButtonDividers,
  DescriptionParas,
  InviteSelectBox,
  TextWrapper
} from "../../InviteInterestedParties/Components/styles";
import { DisplayFlex, TitleTextWrapper,InputField } from "../../../../../CommonComponents/commonStyles";
import { connect } from "react-redux";
import UserAccessLevel from "../../../../MyAccounts/Components/InviteInterestedParties/Components/UserAccessLevel";
import { DividerWrap, ButtonDivider } from "../../../../MyAccounts/Components/Step1Setup/Components/RelatedContributor/styles";
import Calendar from "../../../../../CommonComponents/Calendar/Calendar";
import { ContentMessage, Types } from "../../../../../CommonComponents/ContentMessages";
import Zipcode from "../../../../../CommonComponents/Zipcode/Zipcode";
import PropTypes from 'prop-types';
import { iipDerivedStates } from "../selectors";
import PhoneForm from "../../../../../CommonComponents/Forms/PhoneInputForm";
import EmailForm from "../../../../../CommonComponents/Forms/EmailInputForm";

const rolesDropDown = [
  { desc: "Professional advisor", value :"1" },
  { desc: "Family member/friends", value :"2" },
  { desc: "Other Designated party", value :"3" }
];

class userInfoForm extends React.Component {
  
  disabledDate(current) {
    return current > moment().endOf('day');
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;
    let titleArr = this.props.titleDropDown && this.props.titleDropDown.map(freq => freq.desc);
    let titleData = Array.from(new Set(titleArr));    
    const { formFields } = this.props;    
    return (
      <React.Fragment>
        <UserSessionData />
        <div data-test="userInfoFormBlock">
        <div>
          <ButtonDividers>
            <Divider />
          </ButtonDividers>
          <DescriptionParas>
            <ContentMessage messageId="iipInfo" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page='Invite interested parties' property="field_page_description" defaultMessage="<p>An interested party is a person authorized to access your account. This could be a family member, friend or professional advisor.You can give each advisor one of four access levels to the account: full access, read-only+exchange access, read-only access or paper-statement access (note: no online access comes with paper-statement access).This page allows you to invite the interested parties you choose and then decide the level of access each person has to the account.</p>"/>            
          </DescriptionParas>
          {/*<DescriptionParas className="text-rightalert">
          All fields are required unless marked optional 
          </DescriptionParas>*/}
          <ButtonDivider>
          <Divider />
          <DescriptionParas>
          * indicates required field 
          </DescriptionParas>
          </ButtonDivider>
          <DivisonCategory>
            <p>              
              <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page='Invite interested parties' property="field_type_1_title" defaultMessage="Advisor role details"/>
            </p>
          </DivisonCategory>        
          <Row>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper><TitleMarginTop>Role of Designated person*</TitleMarginTop></TitleWrapper>
                  }>
                  {getFieldDecorator("Role", {
                    rules: [
                      {
                        type: "string"
                      }]
                  })(
                    <SelectOptionMainWrapper>
                      <InputWrapperdropFixedwidth>
                      <SelectdropwownStyles>                      
                        <RelativePositionDiv id="roleWrapper">
                          <InviteSelectBox
                            data-test="inviteRole"
                            aria-label="Select Role"
                            role={false}
                            dropdownClassName="advisorSel"
                            width="300"
                            onBlur={e => this.props.setData(e, 'role', true)}
                            onChange={e => this.props.setData(e, 'role')}
                            getPopupContainer={() => document.getElementById("roleWrapper")}
                            notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                            placeholder="Select Role"
                          >
                            {
                              rolesDropDown && rolesDropDown.map((freq,index) => (
                                <Select.Option value={freq.desc} key={index}>
                                  {freq.desc}                              
                                </Select.Option>
                              ))
                            }
                          </InviteSelectBox>
                        </RelativePositionDiv>
                    </SelectdropwownStyles>
                    </InputWrapperdropFixedwidth>
                    </SelectOptionMainWrapper>
                  )}
                </FormItem>
              </WrapLabel>
              {
                formFields.role.msg && <Err>{ formFields.role.msg }</Err>
              }
            </Col>
          </Row>
          {        
            formFields.role.value === "Professional advisor" && (
              <DescriptionPara>                
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page='Invite interested parties' property="field_type_2_description" defaultMessage="<p>Want to include your attorney, tax advisor, accountant, or financial planner?</p>"/>
              </DescriptionPara>
            )
          }
          {      
            formFields.role.value === "Family member/friends" && (
              <DescriptionPara>                
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page='Invite interested parties' property="field_type_3_description" defaultMessage="<p>Want to involve your friends or family in your philanthropy?</p>"/>
              </DescriptionPara>)
          }
          {     
            formFields.role.value === "Other Designated party" && (
              <DescriptionPara>               
               <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page='Invite interested parties' property="field_type_4_description" defaultMessage="<p>Adding someone from your team to help you reach your charitable goals?</p>"/>
              </DescriptionPara>
            )
          }

          <Row>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper><TitleMarginTop> Firm Name (Optional) </TitleMarginTop></TitleWrapper>
                  }>
                  {getFieldDecorator("firmName", {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    <InputWrapperfixedwidth>
                    <InputField
                      aria-label="Enter firm name"
                      data-test="firm-name-block"
                      value={ formFields.firmName.value }
                      onChange={e => this.props.setData(e.target.value, 'firmName') }                        
                      maxLength={150}                        
                      placeholder="Enter Firm Name"
                      >
                      </InputField>
                  </InputWrapperfixedwidth>
                  )}
                </FormItem>
              </WrapLabel>              
            </Col>
          </Row>          
          <div>
            <RowWrapper>
              <UserAccessLevel {...this.props} />
            </RowWrapper>
          </div>
          <DividerWrap> 
            <Divider />
          </DividerWrap>
          <DivisonCategory>
            <p>              
              <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page='Invite interested parties' property="field_type_8_title" defaultMessage="Personal Information"/>
            </p>
          </DivisonCategory>
          <RowWrapper>
            <Row gutter={24}>              
              <Col lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={<TitleMarginTop><TitleWrapper>Title (Optional)</TitleWrapper></TitleMarginTop>}
                  >
                    {getFieldDecorator("title", { rules: [{ type: "string" }] })(
                      <InputWrapperdropFixedwidth>
                        <SelectOptionMainWrapper>
                            <SelectdropwownStyles>                            
                              <RelativePositionDiv id="titleWrapper" >
                              <InviteSelectBox
                                  data-test="inviteTitle"
                                  aria-label="Select Title"
                                  role={false}
                                  dropdownClassName="advisorSel"
                                  width="300"
                                  onChange={e => this.props.setData(e, 'title')}
                                  getPopupContainer={() => document.getElementById("titleWrapper")}
                                  notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                                  defaultActiveFirstOption={false}
                                  showSearch
                                  placeholder="--"
                                >
                                  {
                                    titleData && titleData.map((freq, index) => {
                                      return (
                                        <Select.Option value={freq} key={index}>
                                          {freq}
                                        </Select.Option>
                                      )
                                    })
                                  }
                                </InviteSelectBox>
                              </RelativePositionDiv>
                            </SelectdropwownStyles>                          
                        </SelectOptionMainWrapper>
                      </InputWrapperdropFixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
              </Col>              
              <Col className="contentWrapper" lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={<TitleMarginTop><TitleWrapper>First Name*</TitleWrapper></TitleMarginTop>}
                  >
                    {getFieldDecorator("firstname", {
                      rules: [
                        {
                          type: "string"
                        }
                      ]
                    })(
                      <InputWrapperfixedwidth>
                        <InputField
                          data-test="firstnameBlock"
                          aria-label="Enter first name"
                          value={formFields.firstName.value}
                          onBlur={e => this.props.setData(e.target.value, 'firstName', true)}
                          onChange={e =>
                            this.props.setData(e.target.value, 'firstName')
                          }
                          placeholder="Enter first name"
                          maxLength={150}
                          ></InputField>
                      </InputWrapperfixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
                {
                  formFields.firstName.msg && <Err>{formFields.firstName.msg}</Err>
                }
              </Col>
            </Row>
          </RowWrapper>
          <RowWrapper>
            <Row gutter={24}>              
              <Col lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper><TitleMarginTop>Middle Name (Optional)</TitleMarginTop></TitleWrapper>
                    }
                  >
                    {getFieldDecorator("MiddleName", {
                      rules: [
                        {
                          type: "string"
                        }]
                    })(
                      <InputWrapperfixedwidth>
                        <InputField  
                          data-test="middleNameBlock"
                          aria-label="Enter middle name"                           
                          onChange={e =>
                            this.props.setData(e.target.value, 'middleName')
                          }
                          value={formFields.middleName.value}
                          placeholder="Enter middle name"
                          maxLength={150}
                        ></InputField>
                      </InputWrapperfixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>                
              </Col>              
              <Col className="contentWrapper" lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper><TitleMarginTop>Last Name*</TitleMarginTop></TitleWrapper>
                    }
                  >
                    {getFieldDecorator("lastName", {
                      rules: [
                        {
                          type: "string"
                        }
                      ]
                    })(
                      <InputWrapperfixedwidth>
                        <InputField
                          data-test="lastnameBlock"
                          aria-label="Enter last name"
                          value={formFields.lastName.value}
                          onBlur={e => this.props.setData(e.target.value, 'lastName', true)}                          
                          onChange={e =>
                            this.props.setData(e.target.value, 'lastName')
                          }
                          placeholder="Enter last name"
                          maxLength={150}
                        ></InputField>
                      </InputWrapperfixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
                {
                  formFields.lastName.msg && <Err>{formFields.lastName.msg}</Err>
                }
              </Col>
            </Row>
          </RowWrapper>
          <RowWrapper>
            <Row gutter={24}>              
              <Col lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper><TitleMarginTop>Suffix (Optional)</TitleMarginTop></TitleWrapper>
                    }
                  >
                    {getFieldDecorator("suffix", {
                      rules: [
                        {
                          type: "string"
                        }
                      ]
                    })(
                      <SelectOptionMainWrapper>
                        <InputWrapperdropFixedwidth>
                        <SelectdropwownStyles>
                          <RelativePositionDiv id="suffixWrapper">
                            <InviteSelectBox
                              data-test="suffixBlock"
                              aria-label="Select Suffix"
                              role={false}
                              dropdownClassName="advisorSel"
                              width="300"
                              onBlur={e => this.props.setData(e, 'suffix', true)}                          
                              onChange={e =>
                                this.props.setData(e, 'suffix')
                              }                              
                              getPopupContainer={() => document.getElementById("suffixWrapper")}
                              notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                              showSearch
                              placeholder="--"
                            >
                              {
                                this.props.suffixDropDown && this.props.suffixDropDown.map((freq,index) => (
                                <Select.Option value={freq.desc} key={index}>
                                  {freq.desc}
                                </Select.Option>
                                ))
                              }
                            </InviteSelectBox>
                          </RelativePositionDiv>
                        </SelectdropwownStyles>
                        </InputWrapperdropFixedwidth>
                      </SelectOptionMainWrapper>
                    )}
                  </FormItem>
                </WrapLabel>
              </Col>              
              <Col className="contentWrapper" lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper><TitleMarginTop>Gender (Optional)</TitleMarginTop></TitleWrapper>
                    }>
                    {getFieldDecorator("gender", {
                      rules: [
                        {
                          type: "string"
                        }]
                    })(
                      <InputWrapperdropFixedwidth>
                        <SelectOptionMainWrapper>
                          <SelectdropwownStyles>
                            <RelativePositionDiv id="genderWrapper">
                              <InviteSelectBox
                                data-test="genderBlock"
                                aria-label="Select Gender"
                                role={false}
                                dropdownClassName="advisorSel"
                                width="300"                            
                                getPopupContainer={() => document.getElementById("genderWrapper")}
                                defaultActiveFirstOption={false}
                                notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                                placeholder="- Select -"
                                onBlur={e => this.props.setData(e, 'gender', true)}                          
                                onChange={e =>
                                  this.props.setData(e, 'gender')
                                }                                
                              >
                                {
                                  this.props.genderDropDown && this.props.genderDropDown.map((freq,index) => (
                                    <Select.Option value={freq.value} key={index}>
                                      {freq.desc}
                                    </Select.Option>
                                  ))
                                }
                              </InviteSelectBox>
                            </RelativePositionDiv>
                          </SelectdropwownStyles>
                        </SelectOptionMainWrapper>
                      </InputWrapperdropFixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
              </Col>
            </Row>
          </RowWrapper>          
          <RowWrapper>
            <Row gutter={24}>
              <Col lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper><TitleMarginTop>Date of Birth*</TitleMarginTop></TitleWrapper>
                    } >
                    {getFieldDecorator("dob")(
                      <InputWrappercal height="22px" className="editAdvisor-DatePicker">
                        <Calendar 
                          data-test="dobBlock"
                          ariaLabel="Select dateofBirth"
                          value={this.props.formFields.dob.value} 
                          readOnly={true} 
                          format='MM/DD/YYYY' 
                          disabledDate={this.disabledDate} 
                          placeHolder='Select Date' 
                          aria-label="date"
                          allowClear={false} 
                          onBlur={(e) => this.props.setData(e, 'dob', true)} 
                          onChange={(date) => this.props.setData(date, 'dob')} />
                      </InputWrappercal>
                    )}
                  </FormItem>
                  {
                    formFields.dob.msg && <Err>{formFields.dob.msg}</Err>
                  }
                </WrapLabel>
              </Col>
            </Row>
          </RowWrapper>          
          <RowWrapper>
            <Row gutter={24}>              
              <Col lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper>
                        <TitleTextWrapper>
                          Last 4 digits of Social Security Number / PIN*
                        </TitleTextWrapper>
                      </TitleWrapper>
                    }
                  >
                    {getFieldDecorator("pin", {
                      rules: [
                        {
                          type: "string",
                        }
                      ]
                    })(
                      <InputWrapperfixedwidth>
                        <SecurityNumWrap>
                          <InputField.Password
                            aria-label="Enter SSN/PIN"
                            data-test="ssn-pin-block"
                            onBlur={e => this.props.setData(e.target.value, 'ssn', true)}                          
                            onChange={e =>
                              this.props.setData(e.target.value, 'ssn')
                            }
                            value={formFields.ssn.value}                             
                            showSearch="false"
                            maxLength={4}                              
                            placeholder="Last four digits only"
                          ></InputField.Password>
                        </SecurityNumWrap>
                      </InputWrapperfixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
                {
                  formFields.ssn.msg && <Err>{formFields.ssn.msg}</Err>
                }
              </Col>              
              <Col className="contentWrapper" lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={
                      <TitleWrapper>
                        <TitleTextWrapper>
                          Confirm last 4 digits of Social Security Number / PIN*
                        </TitleTextWrapper>
                      </TitleWrapper>
                    }>
                    {getFieldDecorator("ssn", {
                      rules: [
                        {
                          type: "string"
                        }]
                    })(
                      <InputWrapperfixedwidth>
                        <SecurityNumWrap>
                          <InputField.Password
                            data-test="confirm-ssn-pin-block"
                            aria-label="Confirm-SSN/PIN"
                            onBlur={e => this.props.setData(e.target.value, 'confirmSsn', true)}                          
                            onChange={e =>
                              this.props.setData(e.target.value, 'confirmSsn')
                            }
                            value={formFields.confirmSsn.value}
                            maxLength={4}                           
                            placeholder="Last four digits only"
                          ></InputField.Password>
                        </SecurityNumWrap>
                      </InputWrapperfixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
                {
                  formFields.confirmSsn.msg && <Err>{formFields.confirmSsn.msg}</Err>
                }
              </Col>
            </Row>
          </RowWrapper>
        </div>
        <DividerWrap>
          <Divider />
        </DividerWrap>
        <DivisonCategory>
          <p>            
            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page='Invite interested parties' property="field_type_9_title" defaultMessage="Contact Information"/>
          </p>
        </DivisonCategory>
        <PhoneForm
         data-test = "phone-form"
          phone  = {this.props.phoneState}
          wrappedComponentRef = {this.props.phoneFormRef}
          handleChange = {this.props.handleFormChange}
              />
              <EmailForm
                data-test='EmailFormBlock'
                email  = {this.props.emailState}
                handleChange = {this.props.handleFormChange}
                wrappedComponentRef = {this.props.emailFormRef}
              />
         <SubDivisonCategory>
          < p>{"Address"} </p>
        </SubDivisonCategory>
        <div>
          <RowWrapper>
            <Row gutter={24}>              
              <Col lg={{ span: 7 }} md={{ span: 9 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={<TitleMarginTop><TitleWrapper>Address Type*</TitleWrapper></TitleMarginTop>}
                  >
                    {getFieldDecorator("AddressType", { rules: [{ type: "string" }] })(
                      <InputWrapperdropFixedwidth>
                        <SelectOptionMainWrapper>                          
                          <SelectdropwownStyles>
                            <RelativePositionDiv id="addressTypeWrapper">
                              <InviteSelectBox
                                data-test="addressTypeBlock"  
                                aria-label="Select address type"
                                role={false}
                                dropdownClassName="advisorSel"
                                width="300"                                
                                getPopupContainer={() => document.getElementById("addressTypeWrapper")}                                  
                                onBlur={e => this.props.setData(e, 'addressType', true)}                
                                onChange={e =>
                                  this.props.setData(e, 'addressType')
                                }
                                defaultActiveFirstOption={false}
                                notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                                placeholder="- Select -">
                                {
                                  this.props.addressDropDown && this.props.addressDropDown.map((freq,index) => (
                                    <Select.Option value={freq.desc} key={index}>
                                      {freq.desc}
                                    </Select.Option>
                                  ))
                                }
                              </InviteSelectBox>
                            </RelativePositionDiv>                            
                          </SelectdropwownStyles>
                        </SelectOptionMainWrapper>
                      </InputWrapperdropFixedwidth>
                    )}
                  </FormItem>
                </WrapLabel>
                {
                  formFields.addressType.msg && <Err>{formFields.addressType.msg}</Err>
                }
              </Col>
            </Row>            
            <Row gutter={24} >
              <Col lg={{ span: 14 }} md={{ span: 10 }}>
                <WrapLabel>
                  <FormItem
                    colon={false}
                    label={<TitleMarginTop><TitleWrapper>Address line 1*</TitleWrapper></TitleMarginTop>}
                  >
                    <TextWrapper>
                      <InputField
                        data-test="line1Block"
                        aria-label="Enter address line1"
                        title="Address Line 1"
                        id={"AddressLine1"}                        
                        maxLength={50}
                        value={formFields.line1.value}
                        onBlur={e => this.props.setData(e.target.value, 'line1', true)}                
                        onChange={e =>
                          this.props.setData(e.target.value, 'line1')
                        }
                        placeholder="Enter address line 1"
                      ></InputField>
                    </TextWrapper>
                  </FormItem>
                </WrapLabel>
                {
                  formFields.line1.msg && <Err>{formFields.line1.msg}</Err>
                }
              </Col>
            </Row>
          </RowWrapper>          
          <Row gutter={24} >
            <Col lg={{ span: 14 }} md={{ span: 10 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={<TitleMarginTop><TitleWrapper>Address line 2 (Optional)</TitleWrapper></TitleMarginTop>}
                >
                  <TextWrapper>
                    <InputField
                      data-test="line2Block"
                      aria-label="Enter address line2"
                      title="Address Line 2 (Optional)"
                      id={"AddressLine2"}
                      value={formFields.line2.value}
                      onChange={e =>
                        this.props.setData(e.target.value, 'line2')
                      }
                      maxLength={50}
                      placeholder="Enter address line 2"
                   ></InputField>
                  </TextWrapper>
                </FormItem>
              </WrapLabel>
            </Col>
          </Row>          
          <Row gutter={24} >
            <Col lg={{ span: 14 }} md={{ span: 10 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={<TitleMarginTop><TitleWrapper>Address line 3 (Optional)</TitleWrapper></TitleMarginTop>}
                >
                  <TextWrapper>
                    <InputField
                      data-test="line3Block"
                      aria-label="Enter address line3"
                      title="Enter address line 3 (Optional)"
                      id={"AddressLine3"}
                      maxLength={50}
                      value={formFields.line3.value}
                      onChange={e =>
                        this.props.setData(e.target.value, 'line3')
                      }
                      placeholder="Enter address line 3"
                    ></InputField>
                  </TextWrapper>
                </FormItem>
              </WrapLabel>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={<TitleMarginTop><TitleWrapper>Country*</TitleWrapper></TitleMarginTop>}
                >
                  {getFieldDecorator("Country", { rules: [{ type: "string" }] })(
                    <InvitePartiesFixedWidth>
                      <SelectOptionMainWrapper>
                        <SelectdropwownStyles>
                          <RelativePositionDiv id="countryWrapper">
                            <InviteSelectBox
                              data-test="countryBlock"
                              role={false}
                              aria-label="Select Country"
                              dropdownClassName="advisorSel"
                              width="300"
                              getPopupContainer={() => document.getElementById("countryWrapper")}
                              onBlur={e => this.props.setData(e, 'country', true)}
                              onChange={e =>
                                this.props.setData(e, 'country')
                              }
                              defaultValue="United States"
                              defaultActiveFirstOption={false}
                              notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                              showSearch
                              onSelect={e => {
                                this.props.resetAllZipCode('zipcode1');
                                this.props.resetZipCode('zipcode1', 'country');
                              }
                              }
                              placeholder="Select Country">
                              {
                                this.props.countryDropDown && this.props.countryDropDown.map((freq,index) => (
                                  <Select.Option value={freq.desc} key={index}>
                                    {freq.desc}
                                  </Select.Option>
                                ))
                              }
                            </InviteSelectBox>
                          </RelativePositionDiv>
                        </SelectdropwownStyles>
                      </SelectOptionMainWrapper>
                    </InvitePartiesFixedWidth>
                  )}
                </FormItem>
              </WrapLabel>
              {
                formFields.country.msg && <Err>{formFields.country.msg}</Err>
              }
            </Col>            
            <Col className="contentWrapper" lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={<TitleMarginTop><TitleWrapper>Zip Code*</TitleWrapper></TitleMarginTop>}
                >
                  <InputWrapperfixedwidth>
                    <Zipcode
                      data-test="zipcodeBlock"
                      ariaLabel="Enter Zip Code"
                      isUS={formFields.country.value === 'United States'}
                      ref={(zip) => this.zipRef = zip}
                      value={formFields.country.value === 'United States' ? formFields.zipcode.value : formFields.zipcodeNonUs.value}
                      title="zipcode1"
                      id="ZipCodePrimary"
                      maxLength={20}
                      onBlur={e => formFields.country.value === 'United States' ? this.props.setData(e.target.value, 'zipcode', true) : this.props.setData(e.target.value, 'zipcodeNonUs', true)}
                      onChange={e => {formFields.country.value === 'United States' ? this.props.setData(e.target.value, 'zipcode') : this.props.setData(e.target.value, 'zipcodeNonUs');}}
                      placeholder="Enter Zip Code"
                    />
                  </InputWrapperfixedwidth>
                </FormItem>
              </WrapLabel>
              {
                formFields.country.value === 'United States' ?
                  formFields.zipcode.msg && <Err>{formFields.zipcode.msg}</Err> :
                  formFields.zipcodeNonUs.msg && <Err>{formFields.zipcodeNonUs.msg}</Err>
              }
            </Col>           
          </Row>
          <Row gutter={24}>            
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
            <WrapLabel>
                <FormItem
                  colon={false}
                  label={<TitleMarginTop><TitleWrapper>City*</TitleWrapper></TitleMarginTop>}
                >
                    <InputWrapperfixedwidth>
                    <InputField
                      data-test="cityBlock"
                      aria-label="Enter City"
                      ref={(city) => this.cityRef = city}
                      value={ formFields.city.value }
                      title="City"
                      id={"City"}
                      onBlur={e => this.props.setData(e.target.value, 'city', true)}
                      onChange={e => {
                        this.props.setData(e.target.value, 'city');
                        this.props.resetZipCode('zipcode1', 'city')                        
                      }
                      }
                      value={
                        this.props.zipCodeData['zipcode1'] && 
                        this.props.zipCodeData['zipcode1'].city ? this.props.zipCodeData['zipcode1'].city : formFields.city.value !== '' ? formFields.city.value : ''
                      }
                      disabled={this.props.zipCodeData['zipcode1'] && this.props.zipCodeData['zipcode1'].loading}
                      maxLength={100}                      
                      placeholder="Enter city"                      
                    ></InputField>                
                    </InputWrapperfixedwidth>
                </FormItem>
                {
                  formFields.city.msg && <Err>{formFields.city.msg}</Err>
                }
              </WrapLabel>
            </Col>            
            <Col className="contentWrapper" lg={{ span: 7 }} md={{ span: 9 }}>
            <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper><TitleMarginTop>State*</TitleMarginTop></TitleWrapper>
                  }>
                  {getFieldDecorator("State", { rules: [{ type: "string" }] })(
                    <InvitePartiesFixedWidth>
                      <SelectOptionMainWrapper>
                        <SelectdropwownStyles>
                          {
                            formFields.country.value === 'United States' ? (
                              <RelativePositionDiv id="stateWrapper">
                                <InviteSelectBox
                                  data-test="stateBlock"
                                  aria-label="Select state"
                                  role={false}
                                  dropdownClassName="advisorSel"
                                  width="300"
                                  getPopupContainer={() => document.getElementById("stateWrapper")}
                                  onBlur={e => this.props.setData(e, 'state', true)}
                                  onChange={e =>
                                    {this.props.resetZipCode('zipcode1', 'state')
                                    this.props.setData(e, 'state')}
                                  }
                                  defaultActiveFirstOption={false}
                                  notFoundContent={<DropDownNoResult>No results</DropDownNoResult>}
                                  showSearch
                                  value={
                                    this.props.zipCodeData['zipcode1'] &&
                                    this.props.zipCodeData['zipcode1'].state ? this.props.zipCodeData['zipcode1'].state : formFields.state.value === '' ? '- Select -' : formFields.state.value
                                  }
                                  dropdown = {this.props.stateDropDown}
                                  disabled={this.props.zipCodeData['zipcode1'] && this.props.zipCodeData['zipcode1'].loading}
                                  placeholder="- Select -">
                                  {
                                    this.props.stateDropDown && this.props.stateDropDown.map((freq,index) => (
                                      <Select.Option value={freq.desc} key={index}>
                                        {freq.desc}
                                      </Select.Option>
                                    ))
                                  }
                                </InviteSelectBox>
                              </RelativePositionDiv>)
                              : (
                                <div id="state">
                                  <InputWrapperfixedwidth>
                                    <InputField
                                      data-test="stateBlock"
                                      aria-label="Enter State"
                                      ref={(stateInput) => this.stateRef = stateInput}
                                      maxLength={100}
                                      title="state"
                                      id="stateField"
                                      onBlur={e => this.props.setData(e.target.value, 'state', true)}
                                      onChange={e =>
                                        this.props.setData(e.target.value, 'state')
                                      }
                                      value={formFields.state.value}
                                      placeholder="Enter State"
                                    ></InputField>
                                  </InputWrapperfixedwidth>
                                </div>
                              )
                          }
                        </SelectdropwownStyles>
                      </SelectOptionMainWrapper>
                    </InvitePartiesFixedWidth>
                  )}
                </FormItem>
              </WrapLabel>
              {
                formFields.state.msg && <Err>{formFields.state.msg}</Err>
              }
            </Col>            
          </Row>
        </div>
        </div>
      </React.Fragment>
    )
  }
}

//Prop types
userInfoForm.propTypes = {
  zipCodeData: PropTypes.objectOf(PropTypes.object),
  resetZipCode: PropTypes.func,
  resetAllZipCode: PropTypes.func,
  setData: PropTypes.func,
  formFields: PropTypes.objectOf(PropTypes.object),
  titleDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      desc: PropTypes.string,
      value: PropTypes.string
    })
  ),
  suffixDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  phoneDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  emailDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  addressDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  stateDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  countryDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  ),
  genderDropDown: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      desc: PropTypes.string
    })
  )
}
//Prop types end

const WrappedUserInfoForm = Form.create({ name: "userInfo" })(userInfoForm);
const mapStateToProps = state => ({
  ...iipDerivedStates(state.toJS())
});

export default connect(mapStateToProps)(WrappedUserInfoForm);